// extracted by mini-css-extract-plugin
export default {"select":"PaKPl0ZTaWah8uVt8amZ","disabled":"ZQCtq6xi5_S02RXWMW0k"};